import logo from './logo.svg';
import './App.css';
import TicTacToe from './TicTacToe.js';

function App() {
  return (
    <div className="App">
      <TicTacToe></TicTacToe>
    </div>
  );
}

export default App;
